import { scopedStorageKey } from "@/lib/storageScope";

const BASE_KEY = "v2_pending_payment_return";

export type PendingPaymentReturn = {
  orderId: string;
  intentId: string | null;
  transactionRef: string;
  providerKey?: string | null;
  providerFamily?: string | null;
  createdAt: number;
};

function keyFor(orderId: string, slug?: string | null): string {
  return scopedStorageKey(`${BASE_KEY}:${orderId}`, slug);
}

export function savePendingPaymentReturn(
  payload: PendingPaymentReturn,
  slug?: string | null,
): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(keyFor(payload.orderId, slug), JSON.stringify(payload));
  } catch {
    /* storage unavailable */
  }
}

export function readPendingPaymentReturn(
  orderId: string,
  slug?: string | null,
): PendingPaymentReturn | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(keyFor(orderId, slug));
    if (!raw) return null;
    return JSON.parse(raw) as PendingPaymentReturn;
  } catch {
    return null;
  }
}

export function clearPendingPaymentReturn(
  orderId: string,
  slug?: string | null,
): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(keyFor(orderId, slug));
  } catch {
    /* storage unavailable */
  }
}
